import { SuperAdminService } from "services/superAdminService";

class PermissionsSAService extends SuperAdminService<any> {
  constructor() {
    super("permissions");
  }
}
export default new PermissionsSAService();
